import { cn } from "@/components/ui/cn";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          className={cn(
            "rounded-full transition-all duration-300",
            i === currentStep
              ? "w-2.5 h-2.5 bg-text-secondary"
              : "w-2 h-2 bg-border-tertiary"
          )}
        />
      ))}
    </div>
  );
}
